import { ApplePayIcon, GooglePayIcon, MastercardIcon, PayPalIcon, VisaIcon } from "@/components/icons";
import { ReactNode } from "react";
import { Wallet } from "@/modules/finance/helper/enums/wallet.enum";
import { PaymentMethod } from "@/modules/finance/helper/enums/payment-method.enum";
import { PaymentMethodLogoProps } from "@/modules/finance/helper/types/payment-method-logo-props.type";

const getWalletIcon = (walletName?: string) => {
  switch (walletName?.toLowerCase()) {
    case Wallet.apple_pay.toLowerCase():
      return (
        <div className="flex w-7.5 h-5 bg-[#F7F8FA] rounded-small items-center justify-center">
          <ApplePayIcon />
        </div>
      );
    case Wallet.google_pay.toLowerCase():
      return (
        <div className="flex w-7.5 h-5 bg-[#F2F0EC] rounded-small items-center justify-center">
          <GooglePayIcon className="w-5" />
        </div>
      );
    default:
      return null;
  }
};

export const paymentMethodIconByMethod: Record<keyof typeof PaymentMethod, ReactNode> = {
  visa: (
    <div className="flex w-7.5 h-5 bg-[#F8F8FA] rounded-small items-center justify-center">
      <VisaIcon />
    </div>
  ),
  mastercard: (
    <div className="flex w-7.5 h-5 bg-[#F2F0EC] rounded-small items-center justify-center">
      <MastercardIcon />
    </div>
  ),
  paypal: (
    <div className="flex w-7.5 h-5 bg-white rounded-small items-center justify-center">
      <PayPalIcon />
    </div>
  ),
};

const getPaymentMethodIcon = (paymentMethodName?: string) => {
  if (paymentMethodName) {
    return paymentMethodIconByMethod[paymentMethodName.toLowerCase() as keyof typeof PaymentMethod] ?? null;
  }
  return null;
};

export const PaymentMethodLogo = ({ paymentMethodName, paymentMethodWallet }: PaymentMethodLogoProps) => {
  const walletIcon = getWalletIcon(paymentMethodWallet);
  const paymentMethodIcon = getPaymentMethodIcon(paymentMethodName);

  return (
    <div className="flex items-center h-5 justify-center gap-2">
      {paymentMethodIcon}
      {walletIcon}
    </div>
  );
};
